export enum ClientMetadataPlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
}

export interface ClientMetadata {
  isBrandedApp?: boolean
  platform?: ClientMetadataPlatform
  gclid?: string
}
